import {
  LoadPropertyDataFailure,
  LoadPropertyDataSuccess,
  SetPropertyBasicDataIsLoaded
} from '@protector/entities/property/__legacy__/redux.actions';
import {
  useGetPropertyBasicInfo as useGetPropertyBasicInfoQuery,
  useGetProperties as useGetPropertiesQuery
} from '@protector/entities/property/queries';
import type { AxiosError } from 'axios';
import { getSelectedPropertyId, getSystemFlags } from 'core/core.selectors';
import { getIsLogged } from 'core/services/auth/auth.selectors';
import { getPropertySelectedInfoBasic } from 'entities/property/property.selectors';
import { transformPropertyData } from 'entities/property/property.service';
import { isEmpty } from 'lodash';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

export const useGetPropertyBasicInfo = () => {
  const property = useSelector(getSelectedPropertyId);
  const dispatch = useDispatch();
  const propertySelectedInfoBasic = useSelector(getPropertySelectedInfoBasic);
  const flags = useSelector(getSystemFlags);
  const isLogged = useSelector(getIsLogged);

  const isPropertyDataNotLoaded = useMemo(
    () => isEmpty(propertySelectedInfoBasic) || property !== propertySelectedInfoBasic.id,
    [property, propertySelectedInfoBasic]
  );

  useEffect(() => {
    if (isPropertyDataNotLoaded) {
      dispatch(SetPropertyBasicDataIsLoaded(false));
    }
  }, [dispatch, isPropertyDataNotLoaded]);

  const { data, isError, error } = useGetPropertyBasicInfoQuery(property ?? undefined, !!property && isLogged);

  useEffect(() => {
    if (!data) return;
    dispatch(LoadPropertyDataSuccess(transformPropertyData(data.data, !!flags?.P40_49783_REMOVE_REVERSE_LONG_LAT)));
  }, [data, dispatch, flags]);

  useEffect(() => {
    if (!isError) return;
    const queryError = error as AxiosError | undefined;
    dispatch(LoadPropertyDataFailure(queryError?.message ?? 'Unknown error'));
  }, [isError, error, dispatch]);
};

export const useGetProperties = (workspaceId: string, enabled: boolean, orgIds?: string[]) => {
  const { data: axiosResponse, isFetching } = useGetPropertiesQuery(workspaceId, orgIds, !!workspaceId && enabled);
  const properties = axiosResponse?.data?.data ?? [];

  return {
    properties,
    isFetching
  };
};
